export default {
  state: {
    isLoading: false,
    snackBar: {
      text: "",
      type: "error"
    }
  },
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setSnackBar(state, payload) {
      state.snackBar = payload;
    }
  },
  actions: {
    setLoading({ commit }, payload) {
      commit("setLoading", payload);
    },
    setSnackBar({ commit }, payload) {
      commit("setSnackBar", payload);
    },
    resetSnackBar({ commit }) {
      commit("setSnackBar", {
        text: '',
        type: ''
      });
    }
  }
};
